const InsightsMainPanel = () => import('client/Insights/InsightsMainPanel.vue');

export default [
  {
    path: '/insights',
    meta: {
      title: 'Directory Insights',
    },
    components: {
      mainPanel: InsightsMainPanel,
    },
  },
];
